// This is useful for our `Note` shape which can be dragged around freely.
export const autoResizePaper = true;
export const borderless = true;
export const scrollWhileDragging = true;
export const cursor = 'default';
export const baseWidth = 10;
export const baseHeight = 10;
